export const FormFields = {
    CUSTOMER_ID: 'customerId',
    JOB_REFERENCE_ID: 'jobReferenceId',
    MRNS: 'mrns',
    CUSTOMS_BROKER_NAME: 'customsBrokerName',
    CUSTOMS_BROKER_EMAIL: 'customsBrokerEmail',
    CUSTOMS_BROKER_PHONE_CODE: 'customsBrokerPhoneCountryCode',
    CUSTOMS_BROKER_PHONE_NUMBER: 'customsBrokerPhoneNumber',
} as const;
